export default "__VITE_ASSET__KjEacQg$__"